<div class="ipm-pro-kits-page-container">
  <div class="ipm-container">
    <div class="ipm-pro-kits-header">
      <div class="ipm-back-button" (click)="navigateToSoundKits()">
        <i class="pi pi-arrow-left"></i>
        <span>Back</span>
      </div>

      <div class="ipm-title-section">
        <div class="ipm-title-wrapper">
          <h1>Royalty <span>Free</span></h1>
        </div>
        <div class="ipm-search-filter">
            <ipm-filter-section 
            [isShowFilterOptions]="false" 
            [isShowSearch]="commonFunction.isMobileDisableClick? false : true"
            [isShowSort]="false"
            [isComponentType]="'royalty-free-sounds'"
            [isShowLayoutChange]="false"
            [searchPlaceholder]="'Search Royalty Free Sound kits'">
          </ipm-filter-section>
        </div>
      </div>
      <div class="separator"></div>
      <div class="ipm-filter-section">
        <ipm-filter-section
          [isShowFilterOptions]="true" 
          [isShowSearch]="commonFunction.isMobileDisableClick? true : false"
          [isShowSort]="false"
          [isComponentType]="'royalty-free-sounds'"
          [searchPlaceholder]="'Search Royalty Free Sound kits'"
          [isShowLayoutChange]="false">
        </ipm-filter-section>
      </div>
    </div>


    <div *ngIf="isDataLoaded" class="ipm-pro-kits-grid">
      <ipm-beats [soundKitsList]="royaltyFreeList" [renderType]="'soundKit'"></ipm-beats>
      <ipm-loading-spinner *ngIf="isShowLoaderPagination"></ipm-loading-spinner>
    </div>
  </div>
</div>
